<template>
  <div>
    <div id="form">
      <h2 class="instH2">Заполните контактную информацию</h2>
      <esia></esia>
<!--      <div id="pasSmartId">-->
<!--        <imageInput v-on:imageData="imageData"></imageInput>-->
<!--      </div>-->
      <!--		<formInput :refs="'LAST_NAME'"></formInput>-->
      <!-- <formSelectDadata :refs="'LAST_NAME'"></formSelectDadata> -->
      <instInput :fieldName="'LAST_NAME'"></instInput>

      <!--		<formInput :refs="'FIRST_NAME'"></formInput>-->
      <!-- <formSelectDadata :refs="'FIRST_NAME'"></formSelectDadata> -->
      <instInput :fieldName="'FIRST_NAME'"></instInput>
      <!--		<formInput :refs="'SECOND_NAME'"></formInput>-->
      <!-- <formSelectDadata :refs="'SECOND_NAME'"></formSelectDadata> -->
      <instInput :fieldName="'SECOND_NAME'"></instInput>
<!--      <formSelectDadata :refs="'RESIDENTIAL_ADDRESS'"></formSelectDadata>-->
<!--      <formInput :refs="'BIRTHDAY'"></formInput>-->
      <!-- <formInput :refs="'PHONE'"></formInput> -->
      <instInput :fieldName="'PHONE'"></instInput>
      <!-- <formInput :refs="'EMAIL'"></formInput> -->
      <instInput :fieldName="'EMAIL'"></instInput>
<!--      <div id="sex">Ваш пол:-->
<!--        <formRadio :refs="'GENDER'" :sman="'M'"></formRadio>-->
<!--        <formRadio :refs="'GENDER'" :sman="'F'"></formRadio>-->
<!--        <span class="errorMsg" v-if="genderVuex.ShowError">{{ genderVuex.msg }}</span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
export default {
  name: 'formFioScreen',
  data() {
    return {
      foto: '',
      smartIdKeyAlias: {
        authority: 'PASSPORT_DEP',
        authority_code: 'PASSPORT_DEP_CODE',
        birthdate: 'BIRTHDAY',
        birthplace: 'BIRTHPLACE',
        gender: 'GENDER',
        issue_date: 'PASSPORT_DATE',
        name: 'FIRST_NAME',
        number: 'PASSPORT_NUMBER',
        number_page2: 'PASSPORT_NUMBER',
        number_page3: 'PASSPORT_NUMBER',
        patronymic: 'SECOND_NAME',
        series: 'PASSPORT_SERIES',
        series_page2: 'PASSPORT_SERIES',
        surname: 'LAST_NAME',
      },
    }
  },
  components: {
    esia: () => import('@/components/esia.vue'),
    instInput: () => import('@/components/inst/instInput.vue'),
    // formInput: () => import('@/views/pdlloan/formInput'),
    // formRadio: () => import('@/views/pdlloan/formRadio'),
    // formSelectDadata: () => import('@/views/pdlloan/formSelectDadata'),
    // imageInput:()=>import('@/components/form/imageInput'),
  },
  methods: {
    gotoEsia() {
      const permissions = [
        'fullname',
        'birthdate',
        'gender',
        'snils',
        'inn',
        'id_doc',
        'birthplace',
        'email',
        'mobile',
        'addresses'
      ]
      const params = {
        client_id: process.env.VUE_APP_ID_ESIA,
        response_type: 'code',
        scope: 'openid',
        // грязно, но в нашем варианте деплоя альтернативы не нашел
        redirect_uri: window.location.href.split('?')[0],
        provider: 'cpg_oauth',
        permissions: permissions.join('+'),
        purposes: 'CREDIT',
        sysname: 'CREDIT',
        actions: 'ALL_ACTIONS_TO_DATA',
        expire: 26297460,
        state: window.token
      }
      const querySrting = Object.entries(params).
        map(([key, value]) => `${key}=${value}`).
        join('&');

      this.$palantir.trackAction(177, `toESIA - ${process.env.VUE_APP_URL_ESIA}/auth/authorize?${querySrting}`);
      location.href = encodeURI(`${process.env.VUE_APP_URL_ESIA}/auth/authorize?${querySrting}`)
    }
  },
  mounted() {

  },
  computed: {
    // ...mapState({
    //   genderVuex: state => state.Form.workData.GENDER,
    // }),
  }
}
</script>
<style scoped>
.instH2{margin-top: 0;}
/* #form > h2 { text-align: left }
#form > p { text-align: left; line-height: 5.60vw }
.errorMsg { color: red; padding-left: 1.60vw; }
.gosuslugi { padding-bottom: 5vw; display: flex; }
.gosuslugi button { align-items: normal; border-radius: 2.67vw; width: calc(100% - 11.76vw); padding: 3.1vw; height: 12.27vw; }
.gosuslugi button img { padding-left: 1.5vw; width: 27vw; }
@media (min-width: 768px) {
  
	.errorMsg { top: 7.8vw}
  
  .gosuslugi { padding-bottom: 2vw; }
  .gosuslugi button { border-radius: 10px; width: 27vw; padding: 1.2vw; height: 4.03vw; margin-left: 0;}
  .gosuslugi button img { padding-top: 0.3vw; padding-left: 0; width: 10vw; }
}
@media (min-width: 1240px) {
	
  .errorMsg { top: 41px }
  
  .gosuslugi button { width: 300px; padding: 12px; height: 50px; }
  .gosuslugi button img { padding: 0 10px; width: 100px; }
} */
</style>
